import React from 'react';
import { OnboardingWrapper } from '../../../components';
import { useOnboarding } from '../../../data-access';
import { Stack, Typography } from '@mui/material';
import lifestackPlanImage from '../../../assets/onboarding/lifestack-plan.png';
import './EnergySituationPage.scss';
import { ReactComponent as BulbIcon } from '../../../assets/onboarding/bulb_icon.svg';

export const EnergySituationPage: React.FC = () => {
  const { currentOnboardingStep, goToNextStep, goToPreviousStep } = useOnboarding();
  const handleContinue = () => {
    goToNextStep();
  };

  return (
    <OnboardingWrapper
      currentOnboardingStep={currentOnboardingStep}
      onBack={goToPreviousStep}
      title="Start working WITH your energy"
      subTitle="Lifestack builds your daily plan around your energy, not your to-do list."
      buttons={[
        {
          text: 'Discover my rhythm',
          onPress: handleContinue,
          variant: 'contained',
        },
      ]}
      contentContainerStyle={{
        display: 'flex',
        marginBottom: '15px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="energy-situation-page">
        <Stack flex={1} alignItems="center" justifyContent="center">
          <img
            src={lifestackPlanImage}
            alt="Daily plan aligned with energy rhythm"
            className="energy-situation-page__image"
          />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          className="energy-situation-page__info-block"
        >
          <BulbIcon className="energy-situation-page__info-block__icon" />
          <Typography variant="subtitle2" className="energy-situation-page__info-block__text">
            By planning around these peaks,{' '}
            <strong>you can boost productivity by up to 20% — without working more hours. </strong>
            <a href="https://www.danpink.com/books/when/" target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
          </Typography>
        </Stack>
      </div>
    </OnboardingWrapper>
  );
};
